import { supabase } from '../lib/supabaseClient';

const memorySignedUrlCache = new Map();

const cacheKey = (bucket, path) => `${bucket}:${path}`;

export const getCachedSignedUrl = async ({ bucket, path, expiresIn = 60 * 60 * 24 * 7 }) => {
  if (!path) return '';

  const key = cacheKey(bucket, path);
  const cached = memorySignedUrlCache.get(key);
  if (cached && cached.expiresAt > Date.now()) {
    return cached.url;
  }

  try {
    const lsKey = `signedUrl:${key}`;
    const raw = localStorage.getItem(lsKey);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed?.url && parsed?.expiresAt > Date.now()) {
        memorySignedUrlCache.set(key, parsed);
        return parsed.url;
      }
    }
  } catch {
    // ignore
  }

  const { data, error } = await supabase.storage.from(bucket).createSignedUrl(path, expiresIn);
  if (error) {
    return '';
  }

  const next = {
    url: data?.signedUrl,
    expiresAt: Date.now() + expiresIn * 1000 - 60 * 1000,
  };

  memorySignedUrlCache.set(key, next);
  try {
    localStorage.setItem(`signedUrl:${key}`, JSON.stringify(next));
  } catch {
    // ignore
  }

  return next.url;
};

export const makeSafeObjectPath = ({ userId, originalName, prefix }) => {
  const rand = crypto.randomUUID();
  const ext = (() => {
    if (!originalName) return 'jpg';
    const parts = originalName.split('.');
    if (parts.length < 2) return 'jpg';
    const raw = parts[parts.length - 1].toLowerCase();
    const safe = raw.replace(/[^a-z0-9]/g, '');
    if (!safe) return 'jpg';
    return safe;
  })();

  return `${prefix}/${userId}/${rand}.${ext}`;
};

export const uploadToBucket = async ({ bucket, path, blob, contentType, cacheControl = '3600' }) => {
  const { data, error } = await supabase.storage.from(bucket).upload(path, blob, {
    contentType,
    cacheControl,
    upsert: true,
  });

  if (error) {
    return { data: null, error };
  }

  return { data, error: null };
};
